var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgViewExpedients = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21.729,
    height: 19.884,
    viewBox: "0 0 21.729 19.884",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vista",
    transform: "translate(-3.71 -4.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1029",
    "data-name": "Path 1029",
    d: "M23.971,7.975H17.6L16.053,5.247a.779.779,0,0,0-.68-.4H7.579A1.36,1.36,0,0,0,6.22,6.209v1.28a.475.475,0,0,1-.477.477H5.169A1.36,1.36,0,0,0,3.81,9.325V23.263a1.277,1.277,0,0,0,1.271,1.271H24.068a1.277,1.277,0,0,0,1.271-1.271V9.334a1.373,1.373,0,0,0-1.368-1.359ZM5.169,23.651a.475.475,0,0,1-.477-.477v-11.4H24.447V23.166a.475.475,0,0,1-.477.477H5.169ZM4.693,10.9V9.334a.475.475,0,0,1,.477-.477h.574A1.36,1.36,0,0,0,7.1,7.5V6.218a.475.475,0,0,1,.477-.477h7.732L16.856,8.46a.779.779,0,0,0,.68.4h6.435a.475.475,0,0,1,.477.477v1.554H4.693Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1030",
    "data-name": "Path 1030",
    d: "M15.162,14.87c-3.4,0-6.082,2.975-6.2,3.107a.433.433,0,0,0,0,.583c.115.124,2.8,3.107,6.2,3.107s6.082-2.975,6.2-3.107a.433.433,0,0,0,0-.583c-.115-.132-2.8-3.107-6.2-3.107Zm0,5.905c-2.41,0-4.5-1.792-5.243-2.516.741-.724,2.842-2.516,5.243-2.516s4.5,1.792,5.243,2.516C19.663,18.983,17.571,20.775,15.162,20.775Z",
    transform: "translate(-0.592 -1.175)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1031",
    "data-name": "Path 1031",
    d: "M14.08,18.485a1.695,1.695,0,1,0,1.695-1.695A1.7,1.7,0,0,0,14.08,18.485Zm2.507,0a.812.812,0,1,1-.812-.812A.81.81,0,0,1,16.587,18.485Z",
    transform: "translate(-1.205 -1.401)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.2
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgViewExpedients, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/view-expedients.d4b99b45.svg";
export { ForwardRef as ReactComponent };